import { EntAgroculturalCooperativeFilter } from "../../../models/filters/agroculturalCooperativeFilter";
import { EntAgroculturalCooperative } from "../../../models/mechanization/agroculturalCooperative";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const agroculturalCooperativeApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgroculturalCooperativeListFiltered: builder.query<ResponseDataGet<EntAgroculturalCooperative>, EntAgroculturalCooperativeFilter>({
      query: (filter) => ({
        url: `${Paths.agroculturalcooperative}/get-all`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),
    getAgroculturalCooperativeList: builder.query<ResponseDataGet<EntAgroculturalCooperative>, void>({
      query: () => ({
        url: `${Paths.agroculturalcooperative}`,
        method: 'GET'
      })
    }),
    getAgroculturalCooperativeById: builder.query<ResponseDataTest<EntAgroculturalCooperative>, number>({
      query: (id) => ({
        url: `${Paths.agroculturalcooperative}/${id}`,
        method: 'GET'
      })
    }),
    addAgroculturalCooperative: builder.mutation<ResponseDataTest<EntAgroculturalCooperative>, EntAgroculturalCooperative>({
      query: (body) => ({
        url: `${Paths.agroculturalcooperative}`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editAgroculturalCooperative: builder.mutation<ResponseDataTest<EntAgroculturalCooperative>, EntAgroculturalCooperative>({
      query: (body) => ({
        url: `${Paths.agroculturalcooperative}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteAgroculturalCooperative: builder.mutation<ResponseDataTest<EntAgroculturalCooperative>, number>({
      query: (id) => ({
        url: `${Paths.agroculturalcooperative}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddAgroculturalCooperativeMutation,
  useDeleteAgroculturalCooperativeMutation,
  useEditAgroculturalCooperativeMutation,
  useLazyGetAgroculturalCooperativeListFilteredQuery
} = agroculturalCooperativeApi;
